module.exports = "<div class=\"epaas-policy-page-container\"></div>";